import {EquipmentScoreType} from '../../../../../types/MarketType';
import type {EquipmentCategoryRange} from '../types/EquipmentCategoryRange';
import {getEquipmentFlagsForShareRange} from './getEquipmentFlagsForShareRange';

const SHARE_RANGE_SPECS: ReadonlyArray<{
  minShare: number | undefined;
  maxShare: number | undefined;
}> = [
  {minShare: undefined, maxShare: 10},
  {minShare: 10, maxShare: 50},
  {minShare: 50, maxShare: 90},
  {minShare: 90, maxShare: undefined},
];

/**
 * Returns all equipment categories (share ranges) with their filtered flags in order.
 * Single source of truth: one variable holding the array of categories mapped to flags.
 */
export function getEquipmentCategories(
  equipmentScore: EquipmentScoreType | undefined
): EquipmentCategoryRange[] {
  if (!equipmentScore) {
    return SHARE_RANGE_SPECS.map((spec) => ({
      ...spec,
      flags: [],
    }));
  }
  return SHARE_RANGE_SPECS.map((spec) => ({
    minShare: spec.minShare,
    maxShare: spec.maxShare,
    flags: getEquipmentFlagsForShareRange(equipmentScore, spec.minShare, spec.maxShare),
  }));
}
